import { Feature } from './feature';
export class ItemsAdministrativeInfo {
    public Price: number;
    public Discount: number;
    public MinCalNr: number;
    public MaxCalNr: number;
    public ProductID: string;
    public ModuleCode: string;
    public EditionCode: string;
    public ObjectType: number;
    public Currency: string;
    public ItemCode: string;
    public MLUItemCode: string;
}

export enum EditionCode {
    std = 'std',
    prm = 'prm',
    pro = 'pro',
    ent = 'ent',
    crs = 'crs',
    crp = 'crp',
    crt = 'crt',
    cre = 'cre',
}
export class ProvisioningDBType {
    Name: string;
    Value: string;
}
export class SubscriptionTokenMode {
    Name: string;
    Value: string;
}

export class IsoCountryCode {
    ISOCountryCode: string;
    Description: string;
    LocalizationCompleted: boolean;
}

export class InstanceObject {
    Value: string;
    Name: string;
}

export class FunctionalityGroup {
    GroupCode: string;
    Name: string;
    ParentGroupCode: string;
    Disabled: number;
    Features: Feature[] = [];
    Children: FunctionalityGroup[] = [];
    GroupPos: number;
    Title: string = '';
    Details: string = '';
}
export class ConfigurationType {
    public static SFT = 'sft';
    public static SAS = 'sas';
}
export class ModuleOptionID {
    public static MC01 = 'MC01';
    public static MCMG = 'MCMG';
    public static MULT = 'MULT';
}
